/**
 * Creates a string representation of the local calendar date from a Date object.
 * This function uses the object's local timezone settings. The output is a string
 * formatted as 'YYYY-MM-DD', directly reflecting this local date without performing
 * any timezone conversions. The time components of the Date object are disregarded
 * in the output string.
 *
 * @param {Date} date - The Date object from which to extract the local calendar date.
 * @returns {string} - A string representing the local calendar date in 'YYYY-MM-DD' format.
 */

const TARGET_DIGIT_LENGTH = 2;
const PADDING_CHAR = '0';

export function dateToLocaleDateString(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1)
    .toString()
    .padStart(TARGET_DIGIT_LENGTH, PADDING_CHAR);
  const day = date
    .getDate()
    .toString()
    .padStart(TARGET_DIGIT_LENGTH, PADDING_CHAR);

  return `${year}-${month}-${day}`;
}
